// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"226fe336","787":"dbc1682a"}[chunkId] + ".chunk.js";
};